import { useMemo, useState } from 'react';
import Pagination from '@/components/feature/Pagination';
import { comments } from '@/mocks/comments';

type Props = {
  dramaId: string;
};

const PAGE_SIZE = 4;

export default function CommentSection({ dramaId }: Props) {
  const [page, setPage] = useState(1);
  const [text, setText] = useState('');
  const [notice, setNotice] = useState('');

  const list = useMemo(() => {
    const forDrama = comments.filter((c) => c.dramaId === dramaId);
    return forDrama.length > 0 ? forDrama : comments;
  }, [dramaId]);

  const totalPages = Math.max(1, Math.ceil(list.length / PAGE_SIZE));
  const pageList = list.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!text.trim()) return;
    setNotice('评论区为演示功能，暂不支持真实提交，感谢你的参与！');
    setText('');
    window.setTimeout(() => setNotice(''), 3500);
  };

  return (
    <section className="mt-12">
      <div className="mb-5 flex items-center gap-2">
        <span className="h-6 w-1.5 rounded-full bg-accent-500" />
        <h2 className="font-heading text-xl font-bold text-foreground-950">观众评论</h2>
        <span className="rounded bg-background-200 px-2 py-0.5 text-xs text-foreground-600">演示模式</span>
      </div>

      <form onSubmit={submit} className="mb-6 rounded-lg border border-background-200 bg-background-50 p-4">
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value.slice(0, 200))}
          rows={3}
          maxLength={200}
          placeholder="说点什么吧，聊聊你对这部剧的看法…（最多 200 字）"
          className="w-full resize-none rounded-md border border-background-200 bg-background-100 p-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-300 focus:outline-none"
        />
        <div className="mt-2 flex items-center justify-between">
          <span className="text-xs text-foreground-400">{text.length}/200</span>
          <button
            type="submit"
            className="h-9 whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            发表评论
          </button>
        </div>
        {notice && (
          <p className="mt-2 rounded-md bg-accent-100 px-3 py-2 text-xs text-accent-800">{notice}</p>
        )}
      </form>

      <ul className="space-y-4">
        {pageList.map((c) => (
          <li key={c.id} className="flex gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-semibold text-primary-700">
              {c.avatar}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-sm font-semibold text-foreground-900">{c.user}</span>
                <span className="text-xs text-foreground-400">{c.time}</span>
              </div>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{c.content}</p>
              <div className="mt-2 flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1"><i className="ri-thumb-up-line" /> {c.likes}</span>
                <span className="flex items-center gap-1"><i className="ri-chat-3-line" /> 回复</span>
              </div>
            </div>
          </li>
        ))}
      </ul>

      <Pagination page={page} totalPages={totalPages} onChange={setPage} />
    </section>
  );
}